import lazySizes from 'lazysizes';
lazySizes.cfg.allowReload = true;
lazySizes.cfg.lazyClass = 'js-lazyload';

export default lazySizes;
